import React from 'react';
import { RefundStripProps } from '../types';
import { useRefundAnimation } from '../../../../../hooks/useRefundAnimation';

const RefundStrip: React.FC<RefundStripProps> = ({
  refundAmount,
  heading_h1,
}) => {
  const { refundTextRef } = useRefundAnimation(refundAmount);

  return (
    <div className="bg-white mt-28 lg:mt-20 mb-5 rounded-3xl w-[600px] text-xl sm:text-sm sm:mb-4 sm:mt-0 text-brand-1000 md:w-[360px] md:text-s-12 md:mt-14 md:mb-4 sm:w-[310px] opacity-0 translate-y-12 animate-[slideIn_0.8s_ease-out_forwards] lg:text-s-14 py-1 px-0 lg:w-[450px] relative">
      <h1 className="bg-green-375 text-xl sm:hidden md:text-s-12 lg:text-s-14 h-full rounded-br-3xl rounded-tr-3xl pr-7 pl-4 text-white font-semibold absolute top-0 flex items-center md:pr-3 md:pl-1">
        <div> {heading_h1}</div>
      </h1>
      <div className="xl:pl-56 lg:pl-44 md:pl-32">
        <span
          className="font-bold text-green-375"
          id="hero-refund-number"
          ref={refundTextRef}
        >
          0.00
        </span>
        <span> Refund processed this year</span>
      </div>
    </div>
  );
};

export default RefundStrip;
